import { Col } from '@opendoor/atoms/box';
import type { Badge, PropertyDetailsFragment } from '__generated__/athena/graphql';
import { Pill } from 'components/marketplace/shared/Pill';

interface PropertyStatusProps {
  property: PropertyDetailsFragment;
}

const DisplayStateStatusMap: Record<Badge, string | undefined> = {
  TEMP_UNAVAILABLE: 'Temporarily unavailable',
  AVAILABLE_SOON: 'Available soon',
  IN_CONTRACT: 'In contract',
  RECENTLY_SOLD: 'Sold',
  ON_THE_MARKET: undefined,
  IS_EXCLUSIVE: undefined,
  TRADITIONAL: undefined,
  UNKNOWN: undefined,
};

export const PropertyStatus = ({ property }: PropertyStatusProps) => {
  if (!property?.listingState || !DisplayStateStatusMap[property?.listingState]) return null;
  return (
    <Col className="pb-6">
      <Pill
        // empty string done for typescript, will never reach that case
        label={DisplayStateStatusMap[property?.listingState] ?? ''}
        rounded
        responsive
      />
    </Col>
  );
};
